import { useMemo } from 'react';
import type { IBlotterColumnDefinition } from 'state/blotters/common/blotter.model';

export function useDisableColumnOptions<Item>(
  columnDefinitions: readonly IBlotterColumnDefinition<Item>[] | undefined,
) {
  return useMemo(
    () =>
      columnDefinitions?.map(
        ({ serverDefaultSort: _serverDefaultSort, precision: _precision, filterable, children, ...others }) => {
          const newChildren = children?.map(({ filterable: filterableChild, ...othersChildren }: any) => {
            if (filterableChild === false) {
              return { ...othersChildren, filter: false };
            }
            return othersChildren;
          });
          if (filterable === false) {
            return { ...others, children: newChildren, filter: false };
          }
          return { ...others, children: newChildren };
        },
      ) ?? [],
    [columnDefinitions],
  );
}

export function useClientSideDisableColumnOptions<Item>(
  columnDefinitions: readonly IBlotterColumnDefinition<Item>[] | undefined,
) {
  return useMemo(
    () =>
      columnDefinitions?.map(
        ({
          serverDefaultSort: _serverDefaultSort,
          precision: _precision,
          filterable: _filterable,
          children,
          ...others
        }) => {
          const newChildren = children?.map(({ filterable: _filterable, ...othersChildren }: any) => othersChildren);
          const columnDefinition = { ...others, children: newChildren } as IBlotterColumnDefinition<Item>;

          return columnDefinition;
        },
      ) ?? [],
    [columnDefinitions],
  );
}
